import { render, staticRenderFns } from "./CompetitionEditApplication.vue?vue&type=template&id=132238f6&"
import script from "./CompetitionEditApplication.vue?vue&type=script&lang=js&"
export * from "./CompetitionEditApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports